var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatbotsecond = function SvgChatbotsecond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#chatbotsecond_svg__a)",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M18 15v-2c0-2.828 0-4.243-.879-5.121C16.243 7 14.828 7 12 7h-2c-2.828 0-4.243 0-5.121.879C4 8.757 4 10.172 4 13v2c0 2.828 0 4.243.879 5.121C5.757 21 7.172 21 10 21h2c2.828 0 4.243 0 5.121-.879C18 19.243 18 17.828 18 15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#chatbotsecond_svg__b)",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M18 17c1.414 0 2.121 0 2.56-.44.44-.439.44-1.146.44-2.56s0-2.121-.44-2.56C20.122 11 19.415 11 18 11"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#chatbotsecond_svg__c)",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M4 17c-1.414 0-2.121 0-2.56-.44C1 16.122 1 15.415 1 14s0-2.121.44-2.56C1.878 11 2.585 11 4 11"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#chatbotsecond_svg__d)",
    strokeWidth: 1.5,
    d: "M12.5 2.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#chatbotsecond_svg__e)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11 4v3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#chatbotsecond_svg__f)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8 12v1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#chatbotsecond_svg__g)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14 12v1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#chatbotsecond_svg__h)",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M9 16.5s.667.5 2 .5 2-.5 2-.5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "chatbotsecond_svg__a",
    x1: 11,
    x2: 11,
    y1: 7,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1177FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#4394FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#1D77EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chatbotsecond_svg__b",
    x1: 19.5,
    x2: 19.5,
    y1: 11,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1177FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#4394FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#1D77EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chatbotsecond_svg__c",
    x1: 2.5,
    x2: 2.5,
    y1: 11,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1177FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#4394FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#1D77EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chatbotsecond_svg__d",
    x1: 11,
    x2: 11,
    y1: 1,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1177FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#4394FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#1D77EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chatbotsecond_svg__e",
    x1: 11.5,
    x2: 11.5,
    y1: 4,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1177FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#4394FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#1D77EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chatbotsecond_svg__f",
    x1: 8.5,
    x2: 8.5,
    y1: 12,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1177FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#4394FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#1D77EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chatbotsecond_svg__g",
    x1: 14.5,
    x2: 14.5,
    y1: 12,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1177FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#4394FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#1D77EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chatbotsecond_svg__h",
    x1: 11,
    x2: 11,
    y1: 16.5,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1177FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#4394FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#1D77EE"
  })))));
};
export default SvgChatbotsecond;